import t from 'rcm-i18n';
import React, {Component} from 'react';
import getSearchQueryParams from './getSearchQueryParams';
import {SearchBoxControllerProps as Props} from './types';

interface State {
    loading?: boolean;
    searchText: string;
}

export default class SearchBoxController extends Component<Props, State> {

    public static defaultProps: Partial<Props> = {
        resultPageUrl: '/search-results',
    };

    constructor(props) {
        super(props);
        this.state = {searchText: getSearchQueryParams().q || ''};
        this.handleSearchTextChange = this.handleSearchTextChange.bind(this);
    }

    public handleSearchTextChange(event) {
        this.setState({searchText: event.target.value});
    }

    public render() {
        return (
            <div>
                {!this.state.loading &&
                <form action={this.props.resultPageUrl + '?q=' + this.state.searchText}>
                    <div className="searchField">
                        <input onChange={this.handleSearchTextChange}
                               value={this.state.searchText || ''}
                               type="text"
                               name="q"
                               autoComplete="off"
                               autoFocus={this.props.autofocus === 'enabled'}
                               size={40} />
                    </div>
                    <div className="searchButton">
                        <button className="glyphicon glyphicon-search plain search">
                            <span>{t('Search')}</span>
                        </button>
                    </div>
                </form>
                }
            </div>
        );
    }
}
